module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as4916-a310a3e7afb197a3ca189a35f1dbac65.jpg";